import { DataTableQuery } from "@/types/dataTableQuery";
import { createContext, PropsWithChildren } from "react";

export const DataTableQueryContext =
  createContext<DataTableQuery<unknown> | null>(null);

interface ProviderProps<Q> extends PropsWithChildren {
  value: DataTableQuery<Q>;
}

export function DataTableQueryContextProvider<Q>({
  children,
  value,
}: ProviderProps<Q>) {
  return (
    <DataTableQueryContext.Provider value={value as DataTableQuery<Q>}>
      {children}
    </DataTableQueryContext.Provider>
  );
}
